import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch, faTrash } from '@fortawesome/free-solid-svg-icons';
import Loader from '../../components/utils/Loader';
import useFetch from '../../hooks/useFetch';
import MainLayout from '../../layouts/MainLayout';
import './BeSure.css';

const BeSureFakeReport = () => {
  const authState = useSelector(state => state.authReducer);
  const [fetchData, { loading }] = useFetch();
  const [searchTerm, setSearchTerm] = useState('');
  const [products, setProducts] = useState([]);
  const [error, setError] = useState('');

  const handleSearchChange = (event) => {
    setSearchTerm(event.target.value);
  };

  const handleSearch = async () => {
    setError('');
    try {
      const response = await fetchData(`/api/beSureFake/search?productName=${encodeURIComponent(searchTerm)}`);
      setProducts(response.data);
    } catch (err) {
      setError('Error fetching data.');
      console.error(err);
    }
  };

  return (
    <MainLayout>
      <div>
        <h2 className='text-lg mt-1 mx-8 border-b border-b-gray-300 text-white'>BeSure - Fake Report</h2>
      </div>
      {/* <div className="main-content"></div> */}
      <div className="m-auto my-2 p-2 border-2 bg-gray-800  shadow-md rounded-md md:w-7/12 w-full">
      {/* <div className='flex flex-col items-center p-6 bg-gray-800 rounded-lg shadow-md w-7/12'> */}
        <h1 className='text-3xl font-bold text-white mb-4'>BeSure Fake Report</h1>

        <div className='w-full max-w-md mb-6'>
          <div className='flex items-center mb-4'>
            <input
              type='text'
              placeholder='Search by product name'
              value={searchTerm}
              onChange={handleSearchChange}
              className='w-full p-2 border border-gray-600 rounded-md'
            />
            <button
              onClick={handleSearch}
              className='ml-2 py-2 px-4 bg-blue-600 text-white rounded-md hover:bg-blue-700'
            >
              <FontAwesomeIcon icon={faSearch} />
            </button>
          </div>

          {loading && <Loader />}
          {error && <p className='text-red-500'>{error}</p>}

          {products.length > 0 && (
            <table className='w-full bg-white border border-gray-200 rounded-md'>
              <thead className='bg-gray-100'>
                <tr>
                  <th className='p-2 border-b border-gray-300 text-left'>Product Code</th>
                  <th className='p-2 border-b border-gray-300 text-left'>Product Name</th>
                  <th className='p-2 border-b border-gray-300 text-left'>Brand</th>
                  <th className='p-2 border-b border-gray-300 text-left'>Batch Number</th>
                  <th className='p-2 border-b border-gray-300 text-left'>Manufacture Date</th>
                  <th className='p-2 border-b border-gray-300 text-left'>Expiry Date</th>
                  <th className='p-2 border-b border-gray-300 text-left'>Actions</th>
                </tr>
              </thead>
              <tbody>
                {products.map((product) => (
                  <tr key={product.productCode}>
                    <td className='p-2 border-b border-gray-300'>{product.productCode}</td>
                    <td className='p-2 border-b border-gray-300'>{product.productName}</td>
                    <td className='p-2 border-b border-gray-300'>{product.productBrand}</td>
                    <td className='p-2 border-b border-gray-300'>{product.batchNumber}</td>
                    <td className='p-2 border-b border-gray-300'>{new Date(product.mfgDate).toLocaleDateString()}</td>
                    <td className='p-2 border-b border-gray-300'>{new Date(product.expDate).toLocaleDateString()}</td>
                    <td className='p-2 border-b border-gray-300'>
                      <button className='text-red-500 hover:text-red-700'>
                        <FontAwesomeIcon icon={faTrash} />
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      </div>
    </MainLayout>
  );
};

export default BeSureFakeReport;
